import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'pr-input-abstract',
    templateUrl: './pr-input-abstract.component.html',
    styleUrls: ['./pr-input-abstract.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PrInputAbstractComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class PrInputAbstractComponent implements AfterViewInit {
  @Input() control: UntypedFormControl;
  @Input() derrors: boolean = false;
  @Input() required: boolean = false;
  @Input() loading: boolean = false;
  @Input() highlightOnValue: boolean = false;
  @Input() highlightOnFocus: boolean = false;

  @Input() disabled: boolean = false;

  @Input() label: string;
  @Input() suffix: string;
  @Input() isDefault: boolean = true;
  @Input() tooltipButton: string;

  hasValue: boolean = false;
  hasFocus: boolean = false;

  constructor() {}

  ngAfterViewInit(): void {
    if (this.control) {
      this.control.valueChanges.subscribe(val => {
        if (typeof val === 'string') {
          this.control.setValue(val.replace(',', '.'), {
            onlySelf: true,
            emitEvent: false,
          });
        }
        this.updateHasValue(val);
      });

      setTimeout(() => {
        this.updateHasValue(this.control.value);
      }, 0);
    }
  }

  private updateHasValue(val: any): void {
    if (val === null || val === undefined) {
      this.hasValue = false;
    } else if (typeof val === 'string') {
      this.hasValue = val.trim() !== '';
    } else if (typeof val === 'object') {
      this.hasValue = true;
    } else {
      this.hasValue = val.toString().trim() !== '';
    }
  }

  labelFinishWithSpace(): boolean {
    return this.label && this.label.slice(-1) == ' ';
  }
}
